import React, { PropTypes } from "react"
import {
  FormGroup,
  ControlLabel,
  Button,
  Row,
  Col,
  Modal,
  Radio,
  FormControl
} from "react-bootstrap"
import Payment from "payment"
import numeral from "numeral"
import Classnames from "classnames"
// LOCAL
import CouponField from "./CouponField"
// SHARED
import { FieldGroup } from "../core/components/FieldGroup"
import { calculateDiscountFromStripeCoupon } from "../utils/AppHelper"

export default class StripeForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.initialState()
  }

  initialState() {
    return {
      sourceType: "card",
      card: {
        number: "",
        cvc: "",
        exp_month: "",
        exp_year: ""
      },
      bank: {
        country: "US",
        currency: "USD",
        routing_number: "",
        account_number: "",
        account_holder_name: "",
        account_holder_type: "company"
      },
      plaid: {
        public_token: "",
        institution_name: "",
        account_name: "",
        account_id: ""
      },
      expiration: null,
      coupon: {
        id: "",
        amount_off: "",
        percent_off: ""
      },
      cc_number_val_state: "",
      cc_exp_val_state: "",
      cc_cvc_val_state: "",
      account_number_val_state: "",
      routing_number_val_state: "",
      quantity: this.props.quantity || 1
    }
  }

  componentDidMount() {
    const script = document.createElement("script")
    script.src = "https://js.stripe.com/v2/"
    document.body.appendChild(script)

    script.addEventListener("load", () => {
      if (window.Stripe) {
        window.Stripe.setPublishableKey(process.env.REACT_APP_STRIPE_PUB_KEY)
      }
    })
  }

  onEnter() {
    Payment.formatCardNumber(document.querySelector("input#cc-number"))
    Payment.formatCardExpiry(document.querySelector("input#cc-exp"))
    Payment.formatCardCVC(document.querySelector("input#cc-cvc"))
  }

  setCCFormValidations() {
    var cc_number_val_state = ""
    var cc_exp_val_state = ""
    var cc_cvc_val_state = ""

    // Set credit card invalid message
    if (!Payment.fns.validateCardNumber(this.state.card.number)) {
      cc_number_val_state = "error"
    }
    if (
      !Payment.fns.validateCardExpiry(
        this.state.card.exp_month,
        this.state.card.exp_year
      )
    ) {
      cc_exp_val_state = "error"
    }
    if (!Payment.fns.validateCardCVC(this.state.card.cvc)) {
      cc_cvc_val_state = "error"
    }

    this.setState(
      Object.assign({}, this.state, {
        cc_number_val_state: cc_number_val_state,
        cc_exp_val_state: cc_exp_val_state,
        cc_cvc_val_state: cc_cvc_val_state
      })
    )
  }

  setBankFormValidations() {
    var account_number_val_state = ""
    var routing_number_val_state = ""

    // Set credit card invalid message
    if (
      !window.Stripe.bankAccount.validateAccountNumber(
        this.state.bank.account_number,
        "US"
      )
    ) {
      account_number_val_state = "error"
    }
    if (
      !window.Stripe.bankAccount.validateRoutingNumber(
        this.state.bank.routing_number,
        "US"
      )
    ) {
      routing_number_val_state = "error"
    }

    this.setState(
      Object.assign({}, this.state, {
        account_number_val_state: account_number_val_state,
        routing_number_val_state: routing_number_val_state
      })
    )
  }

  handleSubmit(e) {
    e.preventDefault()

    const form = this.props.form

    if (this.state.sourceType == "card") {
      // Set validation state
      this.setCCFormValidations()
      const validCardNumber = Payment.fns.validateCardNumber(
        this.state.card.number
      )
      const validExpiry = Payment.fns.validateCardExpiry(
        this.state.card.exp_month,
        this.state.card.exp_year
      )
      const validCVC = Payment.fns.validateCardCVC(this.state.card.cvc)

      if (validCardNumber && validExpiry && validCVC) {
        // Dispatch form submit events
        // this.props.onSubmitFormDispatch()

        window.Stripe.createToken(
          this.state.card,
          function(status, response) {
            // calls the createSubscription or updateSubscription actions directly:
            this.props.onReceiveStripeCardToken(
              response.id,
              this.state.coupon.id,
              this.state.quantity,
              this.state.sourceType,
              this.state.plaid.account_id
            )
            // Reset state
            this.setState(this.initialState())
            document.querySelector("input#cc-exp").value = ""
            document.querySelector("input#coupon")
              ? (document.querySelector("input#coupon").value = "")
              : ""
          }.bind(this)
        )
      }
    } else if (this.state.sourceType == "invoice") {
      this.props.onReceiveStripeCardToken(
        "send_invoice", //as stripe_card_token
        this.state.coupon.id,
        this.state.quantity,
        this.state.sourceType,
        this.state.plaid.account_id
      )
    } else {
      // Send plaid public token
      if (this.state.plaid.public_token) {
        this.props.onReceiveStripeCardToken(
          this.state.plaid.public_token,
          this.state.coupon.id,
          this.state.quantity,
          this.state.sourceType,
          this.state.plaid.account_id
        )
      }

      // Set validation state
      // this.setBankFormValidations()
      // const validRoutingNumber = Stripe.bankAccount.validateRoutingNumber(this.state.bank.routing_number, 'US');
      // const validAccountNumber = Stripe.bankAccount.validateAccountNumber(this.state.bank.account_number, 'US');
      //
      // if ( validRoutingNumber && validAccountNumber) {
      //   // Dispatch form submit events
      //   this.props.onSubmitFormDispatch()
      //
      //   console.log("Stripe.bankAccount.createToken");
      //   console.log(this.state.bank);
      //
      //   Stripe.bankAccount.createToken(this.state.bank, function (status, response) {
      //     console.log("response.id");
      //     console.log(response.id);
      //
      //     this.props.onReceiveStripeCardToken(response.id, this.state.coupon.id, this.state.quantity)
      //     // Reset state
      //     this.setState(this.initialState());
      //   }.bind(this));
      // }
    }
  }

  handleChange(e) {
    let card = this.state.card
    let coupon = this.state.coupon
    let expiration = this.state.expiration
    let quantity = this.state.quantity
    let bank = this.state.bank

    switch (e.target.name) {
      case "expiration":
        const expiration_arr = e.target.value.split("/")
        card["exp_month"] = parseInt(expiration_arr[0], 10)
        card["exp_year"] = parseInt(expiration_arr[1], 10)
        expiration = e.target.value

        this.setState(
          Object.assign({}, this.state, {
            cc_exp_val_state: ""
          })
        )

        break
      case "coupon":
        coupon.id = e.target.value

        break
      case "quantity":
        if (!isNaN(Number(e.target.value))) {
          let decimal = /\./
          if (!decimal.test(e.target.value)) {
            quantity = e.target.value
          }
        }

        break
      case "cvc":
        card[e.target.name] = e.target.value

        this.setState(
          Object.assign({}, this.state, {
            cc_cvc_val_state: ""
          })
        )

        break
      default:
        if (this.state.sourceType == "card") {
          card[e.target.name] = e.target.value

          this.setState(
            Object.assign({}, this.state, {
              cc_number_val_state: ""
            })
          )
        } else {
          bank[e.target.name] = e.target.value
        }
    }

    let state = { card, bank, expiration, coupon, quantity }
    this.setState(state)
  }

  handleReceiveCouponSuccess(coupon_json) {
    let card = this.state.card
    let coupon = this.state.coupon
    let expiration = this.state.expiration

    coupon.amount_off = coupon_json.coupon.amount_off
    coupon.percent_off = coupon_json.coupon.percent_off

    let state = { card, expiration, coupon }
    this.setState(state)
  }

  handleReceiveCouponError() {
    let card = this.state.card
    let coupon = this.state.coupon
    let expiration = this.state.expiration

    coupon.amount_off = ""
    coupon.percent_off = ""

    let state = { card, expiration, coupon }
    this.setState(state)
  }

  handleCancel() {
    this.setState(this.initialState())
    this.props.onCancel()
  }

  handlePaymentSourceChange(type) {
    // Change payment source tab
    this.setState(Object.assign({}, this.state, { sourceType: type }))
  }
  handleAddBankInformation() {
    // Open Plaid link
    var linkHandler = window.Plaid.create({
      env: process.env.REACT_APP_PLAID_ENV,
      // apiVersion: 'v2',
      clientName: "Everlance",
      key: "a69e742ae797b85b9f651cf8784d8a",
      product: ["auth"],
      selectAccount: true,
      onSuccess: function(public_token, metadata) {
        // Send the public_token and account ID to your app server.
        // console.log('public_token: ' + public_token);
        // console.log('metadata: ');
        // console.log(metadata);

        this.setState(
          Object.assign({}, this.state, {
            ...this.state,
            plaid: {
              public_token: public_token,
              institution_name: metadata.institution.name,
              account_name: metadata.account.name,
              account_id: metadata.account_id
            }
          })
        )
      }.bind(this),
      onExit: function(err, metadata) {
        // The user exited the Link flow.
        if (err != null) {
          // The user encountered a Plaid API error prior to exiting.
        }
      }
    })

    linkHandler.open()
  }

  handleAccountTypeChange(event) {
    this.setState(
      Object.assign({}, ...this.state, {
        bank: { ...this.state.bank, account_holder_type: event.target.value }
      })
    )
  }

  render() {
    const form = this.props.form
    const {
      showStripeModal,
      modalTitle,
      total,
      interval,
      potentialCredits,
      groupCoupon,
      groupCouponLabel,
      productIdentifier,
      isGroup,
      updateSourceOnly,
      pricePerActive
    } = this.props

    const submitBtnClass = Classnames({
      submitting: form.submitting,
      "btn-main-blue": !form.success,
      "btn-main-green": form.success
    })

    const totalFieldClass = Classnames({
      "display-none": !this.props.totalField,
      "margin-top": true
    })
    const couponFieldClass = Classnames({
      "display-none": !this.props.couponField
    })

    const circleStyle = {
      strokeDasharray: "240px, 240px",
      strokeDashoffset: "480px"
    }
    const pathStyle = {
      strokeDasharray: "50px, 50px",
      strokeDashoffset: "0px"
    }
    const fullWidth = {
      width: "100% ",
      textAlign: "center"
    }
    const errorsBox = {
      width: "100% ",
      textAlign: "center",
      color: "#d02f2f",
      marginTop: "15px"
    }
    const btnInlineStyle = {
      width: "100%",
      height: "45px",
      fontSize: "18px"
    }

    const checkmark = (
      <span className="icon icon--order-success inlinesvg svg">
        <svg width="26px" height="26px">
          <g fill="none" stroke="#FFFFFF" stroke-width="2">
            <circle cx="13" cy="13" r="12" style={circleStyle} />
            {/*<path d="M19.417,37.778l9.93,9.909l20.444-22.393" style={pathStyle}></path>*/}
            <path d="M5.817,13.778l4.93,4.909l9.444-11.393" style={pathStyle} />
          </g>
        </svg>
      </span>
    )

    var buttonContent
    if (form.success) {
      buttonContent = checkmark
    } else {
      buttonContent = form.submitting
        ? this.props.buttonTitleSubmitting
        : this.props.buttonTitle
    }

    var errorMessage
    if (form.error) {
      errorMessage = form.error_message
    } else {
      errorMessage = null
    }

    // Set credits row
    let potentialCreditsRow = null
    if (
      potentialCredits > 0 &&
      this.props.productIdentifier == "stripe.yearly.premium"
    ) {
      potentialCreditsRow = (
        <Row>
          <Col xs={12} sm={12}>
            <FormGroup
              controlId="stripe-form-total"
              className={totalFieldClass}
            >
              <ControlLabel className="total-label">Credits</ControlLabel>
              <p className="total-price">-${potentialCredits.toFixed(2)}</p>
            </FormGroup>
          </Col>
        </Row>
      )
    }
    let potentialCreditsTotal = 0
    if (this.props.productIdentifier == "stripe.yearly.premium") {
      potentialCreditsTotal = potentialCredits
    }

    // Set coupon discount row
    let couponDiscountTotal = calculateDiscountFromStripeCoupon(
      this.state.coupon,
      total * this.state.quantity
    )
    let couponRow = null
    // Set coupon row if there is no group discount
    if (!isGroup && couponDiscountTotal && couponDiscountTotal != 0) {
      couponRow = (
        <Row>
          <Col xs={12} sm={12}>
            <FormGroup
              controlId="stripe-form-total"
              className={totalFieldClass}
            >
              <ControlLabel className="total-label">Coupon</ControlLabel>
              <p className="total-price">-${couponDiscountTotal.toFixed(2)}</p>
            </FormGroup>
          </Col>
        </Row>
      )
    }

    // Set plan total row
    let planTotalRow = null
    if (couponRow || potentialCreditsRow) {
      planTotalRow = (
        <Row>
          <Col xs={12} sm={12}>
            <FormGroup
              controlId="stripe-form-total"
              className={totalFieldClass}
            >
              <ControlLabel className="total-label">Plan</ControlLabel>
              <p className="total-price">
                ${numeral(
                  parseFloat(total).toFixed(2) * this.state.quantity
                ).format("0,0.00")}
              </p>
            </FormGroup>
          </Col>
        </Row>
      )
    }

    let trialDaysTotal = null
    if (this.props.trial_period_days) {
      trialDaysTotal = (
        <Row>
          <Col xs={12} sm={12} className="border-top">
            <FormGroup
              controlId="stripe-form-total"
              className={totalFieldClass}
            >
              <ControlLabel className="total-label">
                Total during trial
              </ControlLabel>
              <p className="total-price">$0.00</p>
            </FormGroup>
          </Col>
        </Row>
      )
    }

    // Set modal title element
    let modalTitleElement = null
    if (productIdentifier == "stripe.monthly.premium.group") {
      modalTitleElement = <Modal.Title>{modalTitle} - Teams</Modal.Title>
    } else {
      modalTitleElement = <Modal.Title>{modalTitle}</Modal.Title>
    }

    const creditCardClass = Classnames({
      "btn btn-default": true,
      selected: this.state.sourceType == "card"
    })
    const bankAccountClass = Classnames({
      "btn btn-default": true,
      selected: this.state.sourceType == "bank"
    })
    const invoiceClass = Classnames({
      "btn btn-default": true,
      selected: this.state.sourceType == "invoice"
    })
    const dialogClassName = Classnames({
      "custom-modal stripe-form-modal": true,
      "": this.props.isGroup
    })

    // Set totals
    const grandTotal = (
      parseFloat(total) * this.state.quantity -
      potentialCreditsTotal -
      couponDiscountTotal
    )
      // groupCouponDiscountTotal
      .toFixed(2)
    var totalPerUserLabel = ""
    if (this.state.quantity > 1) {
      totalPerUserLabel = `(${numeral(grandTotal / this.state.quantity).format(
        "$0,0.00"
      )}/user)`
    }

    return (
      <div className="subscription-form-box">
        <Modal
          bsSize="small"
          show={showStripeModal}
          onHide={this.handleCancel.bind(this)}
          onEnter={this.onEnter.bind(this)}
          dialogClassName={dialogClassName}
        >
          <Modal.Header closeButton>{modalTitleElement}</Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit.bind(this)}>
              {isGroup && (
                <div>
                  {!updateSourceOnly && (
                    <Row>
                      <Col xs={12}>
                        <FieldGroup
                          id="quantity"
                          type="text"
                          label="How many users do you need?"
                          placeholder="Enter the number of users"
                          name="quantity"
                          value={this.state.quantity}
                          onChange={this.handleChange.bind(this)}
                        />
                      </Col>
                    </Row>
                  )}

                  <Row>
                    <Col xs={12}>
                      <ControlLabel>Payment Method</ControlLabel>
                    </Col>
                    <Row className="payment-methods">
                      <a
                        className={creditCardClass}
                        onClick={function() {
                          this.handlePaymentSourceChange("card")
                        }.bind(this)}
                      >
                        Credit Card
                      </a>

                      <a
                        className={bankAccountClass}
                        onClick={function() {
                          this.handlePaymentSourceChange("bank")
                        }.bind(this)}
                      >
                        Bank Account
                      </a>

                      <a
                        className={invoiceClass}
                        onClick={function() {
                          this.handlePaymentSourceChange("invoice")
                        }.bind(this)}
                      >
                        Invoice
                      </a>
                    </Row>
                  </Row>
                </div>
              )}

              {this.state.sourceType == "card" && (
                <div>
                  <Row>
                    <Col xs={12}>
                      <FieldGroup
                        id="cc-number"
                        type="text"
                        label="Card Number"
                        placeholder=""
                        name="number"
                        value={this.state.card.number}
                        onChange={this.handleChange.bind(this)}
                        validationState={this.state.cc_number_val_state}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6} sm={6}>
                      <FieldGroup
                        id="cc-exp"
                        type="text"
                        label="Expiration"
                        placeholder="MM / YY"
                        name="expiration"
                        value={this.state.card.expiration}
                        onChange={this.handleChange.bind(this)}
                        validationState={this.state.cc_exp_val_state}
                      />
                    </Col>
                    <Col xs={6} sm={6}>
                      <FieldGroup
                        id="cc-cvc"
                        type="text"
                        label="CVC"
                        placeholder=""
                        name="cvc"
                        value={this.state.card.cvc}
                        onChange={this.handleChange.bind(this)}
                        validationState={this.state.cc_cvc_val_state}
                      />
                    </Col>
                  </Row>
                </div>
              )}

              {this.state.sourceType == "invoice" && (
                <div style={{ padding: 30, fontSize: 16, fontWeight: 600 }}>
                  An invoice will be sent to {this.props.email}
                </div>
              )}

              {this.state.sourceType == "bank" && (
                <div>
                  <Row>
                    {this.state.plaid.public_token && (
                      <Col xs={12}>
                        <Col xs={6}>
                          <div>
                            <p>
                              {this.state.plaid.institution_name} <br />
                              {this.state.plaid.account_name}
                            </p>
                          </div>
                        </Col>
                        <Col xs={6}>
                          <div
                            className="btn btn-default"
                            onClick={this.handleAddBankInformation.bind(this)}
                          >
                            Change
                          </div>
                        </Col>
                      </Col>
                    )}
                    {!this.state.plaid.public_token && (
                      <Col
                        xs={12}
                        className="full-width-center-text margin-bottom"
                      >
                        <div
                          className="btn btn-md btn-default"
                          onClick={this.handleAddBankInformation.bind(this)}
                        >
                          Add Bank Account
                        </div>
                      </Col>
                    )}

                    <br />
                    <br />
                  </Row>
                </div>
              )}

              <Row>
                {!isGroup && (
                  // !this.props.trial_period_days && (
                  <CouponField
                    id="coupon"
                    type="text"
                    label="Coupon"
                    placeholder="Enter code (optional)"
                    name="coupon"
                    value={this.state.coupon}
                    onChange={this.handleChange.bind(this)}
                    className={couponFieldClass}
                    onReceiveCouponSuccess={this.handleReceiveCouponSuccess.bind(
                      this
                    )}
                    onReceiveCouponError={this.handleReceiveCouponError.bind(
                      this
                    )}
                  />
                )}
              </Row>

              {planTotalRow}
              {potentialCreditsRow}
              {couponRow}

              <Row>
                <Col xs={12} sm={12} className="border-top">
                  <FormGroup
                    controlId="stripe-form-total"
                    className={totalFieldClass}
                  >
                    <ControlLabel className="total-label">
                      Total {totalPerUserLabel}
                    </ControlLabel>
                    <p className="total-price">
                      {numeral(grandTotal).format("$0,0.00")}
                    </p>
                  </FormGroup>
                </Col>
              </Row>
              {trialDaysTotal}
              <div className="full-width-center-text" style={fullWidth}>
                <Button
                  disabled={form.submitting || form.success}
                  className={submitBtnClass}
                  style={btnInlineStyle}
                  type="submit"
                >
                  {buttonContent}
                </Button>
              </div>
              <div style={errorsBox}>{errorMessage}</div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

StripeForm.propTypes = {
  form: PropTypes.object.isRequired,
  onReceiveStripeCardToken: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/subscriptions/StripeForm.js